/** The finalized feature label used throughout hacker navigation. */
export const MENTOR_CAFE_NAV_COPY = {
  text: "Mentor Cafe",
  status: "final",
} as const;
